import { AuthenticationApi, Configuration, TokenDto, UserDto } from "@desio/api";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "store";
import getConfiguration from "../../../store/config";
import { requestManagement } from "../../../store/utils";

export const setAccessTokenAdminAction = createAction<string, 'setAccessTokenAdminAction'>('setAccessTokenAdminAction');
export const resetAccessTokenAdminAction = createAction<void, 'resetAccessTokenAdminAction'>('resetAccessTokenAdminAction');

export const loginAdmin = createAsyncThunk<TokenDto | undefined, string, ThunkApiConfig>(
  'authentication/loginAdmin', async (userToken, { dispatch, extra, getState }) => {
    console.log('userToken', userToken);
    const mock = extra.mock ? '../../../mock/login-admin.json' : undefined;
    return await requestManagement(() => new AuthenticationApi(getConfiguration(Configuration, extra, getState)).apiAuthenticationLoginAdminGet({ userToken }), dispatch, mock)
  }
);

export const userInfo = createAsyncThunk<UserDto | undefined, void, ThunkApiConfig>(
  'authentication/userInfo', async (_, { dispatch, extra, getState }) => {
    const mock = extra.mock ? "../../../mock/user-info.json" : undefined;
    return await requestManagement(() => new AuthenticationApi(getConfiguration(Configuration, extra, getState)).apiAuthenticationUserInfoGet(), dispatch, mock)
  }
);
